module.exports = __webpack_public_path__ + "fonts/4be1a57.eot";